module.exports = __webpack_public_path__ + "img/05.04ea6f46.png";